import { getOddDisplayValue } from '@core/services/offer/helpers';
import { BetBuilderMarket } from '../types/BetBuilderMarket';
import { BetBuilderMarkets } from '../types/BetBuilderMarkets';
import {
    BetBuilderOdd,
    BetBuilderOddStatus,
} from '../types/BetBuilderOdd';
import { BetBuilderMarketDto } from '../types/dtos/BetBuilderMarketDto';
import { BetBuilderMarketsDto } from '../types/dtos/BetBuilderMarketsDto';
import { BetBuilderOddDto } from '../types/dtos/BetBuilderOddDto';

export function transformBetBuilderMarkets(dto: BetBuilderMarketsDto): BetBuilderMarkets {
    return {
        matchId: dto.matchId,
        markets: dto.markets?.map((market) => transformBetBuilderMarket(market)) ?? [],
    };
}

export function transformBetBuilderMarket(dto: BetBuilderMarketDto): BetBuilderMarket {
    return {
        id: dto.id,
        name: dto.name,
        odds: dto.odds.map((odd) => transformOdd(odd)),
    };
}

function transformOdd(dto: BetBuilderOddDto): BetBuilderOdd {
    const specialBetValue = computeSpecialBetValue(dto.specifiers);
    const displayValue = getOddDisplayValue(dto.name, Boolean(specialBetValue && dto.name !== specialBetValue), specialBetValue);

    return {
        outcomeId: dto.outcomeId,
        marketUuid: dto.marketUuid,
        uuid: dto.uuid,
        name: dto.name,
        description: dto.description,
        displayValue,
        price: dto.price,
        status: dto.status as BetBuilderOddStatus,
        specifiers: dto.specifiers,
        specialBetValue,
    };
}

function computeSpecialBetValue(specifiers?: Record<string, string>): string {
    if (!specifiers) {
        return '';
    }

    const specifiersKeys = Object.keys(specifiers).sort();
    if (specifiersKeys.length === 0) {
        return '';
    }

    return specifiersKeys
        .map((key) => specifiers[key])
        .join('-');
}
